import { z } from 'zod';

export const hpgMuestraFormSchema = z.object({
  identificacion: z.string().nullable(),
  valor: z.number().min(0).nullable(),
  observacion: z.string().nullable(),
});

export const hpgFormSchema = z.object({
  fecha_analisis: z.date({ message: 'Fecha de análisis inválida' }),
  identificacion_muestras: z.string().nullable(),
  alimentacion: z.string().nullable(),
  ultimo_antiparasitario: z.string().nullable(),
  fecha_ultimo_tratamiento: z.date().nullable(),
  comentarios_lote: z.string().nullable(),
  muestras: z.array(hpgMuestraFormSchema).min(1).max(25),
});

export type HpgMuestraFormValues = z.infer<typeof hpgMuestraFormSchema>;
export type HpgFormValues = z.infer<typeof hpgFormSchema>;

export function esMuestraVacia(m: HpgMuestraFormValues): boolean {
  return !m.identificacion && m.valor === null && !m.observacion;
}
